import { inject, Pipe, PipeTransform } from '@angular/core';
import { EmailNotificationSettingEnum } from '../enums/email-notification-setting.enum';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'emailNotificationSettings'
})
export class EmailNotificationSettingsPipe implements PipeTransform {
  translocoService = inject(TranslocoService);
  transform(value: EmailNotificationSettingEnum | undefined | null): unknown {
    if (!value) {
      return this.translocoService.translate('label.unknown');
    }
    return this.emailNotificationSetting(value);
  }

  emailNotificationSetting(setting: EmailNotificationSettingEnum): string {
    switch (setting) {
      case EmailNotificationSettingEnum.cancellation:
        return this.translocoService.translate('location.email_notification_setting.cancellation');
      case EmailNotificationSettingEnum.initial:
        return this.translocoService.translate('location.email_notification_setting.initial');
      case EmailNotificationSettingEnum.note:
        return this.translocoService.translate('location.email_notification_setting.note');
      case EmailNotificationSettingEnum.booking:
        return this.translocoService.translate('location.email_notification_setting.booking');
      default:
        return this.translocoService.translate('label.unknown');
    }
  }
}
